module.exports = __webpack_public_path__ + "static/media/20.9b118899.png";